<template>
  <div
    id="m_quick_sidebar"
    class="m-quick-sidebar m-quick-sidebar--tabbed m-quick-sidebar--skin-light m-quick-sidebar--on"
  >
    <div class="m-quick-sidebar__content">
      <span class="m-quick-sidebar__close mt-2" @click="closeThis()"
        ><i class="fal fa-times-circle fa-lg"></i
      ></span>
      <div class="titleForm pb-3 pt-3" id="titleForm">
        <h5>
          <span class="far fa-history"></span> Histórico de envio de e-mails
        </h5>
      </div>
    </div>
    <hr />
    <div class="table-responsive">
      <div class="container-table">
        <table class="table table-bordered">
          <thead>
            <tr>
              <th class="text-center no-wrap">Enviado Por</th>
              <th class="text-center no-wrap">ID Fatura</th>
              <th class="text-center no-wrap">ID Cliente</th>
              <th class="text-center no-wrap">Produto</th>
              <th class="text-center no-wrap">Mês Fatura</th>
              <th class="text-center no-wrap">Log</th>
              <th class="text-center no-wrap">Status</th>
              <th class="text-center no-wrap">Destinararios</th>
              <th class="text-center no-wrap">Data</th>
            </tr>
          </thead>
          <tbody>
            <template v-for="(audit, index) in data">
              <tr
                data-toggle="collapse"
                :data-target="'#fields' + index"
                class="clickable pointer"
                :key="index"
              >
                <td class="text-center">{{ audit.username }}</td>
                <td class="text-center">{{ audit.id }}</td>
                <td class="text-center">{{ audit.customer_id }}</td>
                <td class="text-center">{{ audit.name }}</td>
                <td class="text-center">{{ audit.billing_month | date }}</td>
                <td class="text-center">{{ audit.log }}</td>
                <td
                  class="text-center font-weight-bold"
                  :class="getStatusClass(audit.status)"
                >
                  {{ getStatus(audit.status) }}
                </td>
                <td class="text-center">{{ audit.emails_sended }}</td>
                <td class="text-center">{{ audit.created_at | datetime }}</td>
              </tr>
            </template>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
import { returnMessageFormMixin } from '@/mixins/returnMessageFormMixin';
import { baseApiUrl } from '@/global';
import axios from 'axios';
import { statusSendEmail } from '../../constants';

// Limite de logs carregados no histórico da fatura.
const MAX_LOGS = 100;

export default {
  mixins: [returnMessageFormMixin],
  name: 'LogSendEmail',
  setup() {
    return {
      statusSendEmail, // Retornando a constante para o template
    };
  },
  data() {
    return {
      statusSendEmail,
      data: [],
      page: 1,
    };
  },
  methods: {
    closeThis() {
      this.$emit('updateList');
      this.$store.state.showLogEmail = null;
    },
    getDatas() {
      const url = `${baseApiUrl}/v1/audits/omie-email-send-log?invoiceId=${this.invoiceId}&amount=${MAX_LOGS}`;
      axios(url).then((res) => {
        // O endpoint retorna o objeto de paginação; a lista fica em "data".
        this.data = res.data.data || [];
      });
    },
    getStatus(status) {
      switch (Number(status)) {
        case statusSendEmail.SUCCESS:
          return 'Sucesso';
        case statusSendEmail.AWAITING_INVOICE:
          return 'Aguardando faturamento';
        case statusSendEmail.AWAITING_NFSE:
          return 'Aguardando NFS-e';
        default:
          return 'Erro';
      }
    },
    getStatusClass(status) {
      switch (Number(status)) {
        case statusSendEmail.SUCCESS:
          return 'statusSuccess';
        case statusSendEmail.AWAITING_INVOICE:
        case statusSendEmail.AWAITING_NFSE:
          return 'statusAwaiting';
        default:
          return 'statusError';
      }
    },
  },
  mounted() {
    this.getDatas();
  },
  computed: {
    invoiceId() {
      return this.$store.state.showLogEmail;
    },
  },
};
</script>

<style scoped>
.titleForm {
  color: #6f727d;
}
.statusSuccess {
  color: #00d86b;
}
.statusError {
  color: #ff7575;
}
.statusAwaiting {
  color: #f0ad4e;
}
</style>